<script setup lang="ts">
import type { IFeatureItem } from '../../../models'
import { ElIcon, IconNames } from '../../icons'

interface TProps {
  model: IFeatureItem
}

const props = withDefaults(defineProps<TProps>(), {
  model: () => {
    return {
      key: 'not-set',
      iconName: IconNames.defaultIcon,
      header: '',
      text: '',
    }
  },
})
/*
  // learn more link:
  <p class="mt-6 hidden">
    <a href="#" class="content-secondary text-sm font-semibold leading-6"
      >Learn more <span aria-hidden="true">→</span></a
    >
  </p>
  */
</script>

<template>
  <div class="flex flex-col">
    <div class="leading-7">
      <div class="bg-primary content-primary mb-6 flex h-10 w-10 items-center justify-center rounded-lg">
        <ElIcon :name="model.iconName" />
      </div>
      <span v-if="model.header" class="text-base font-bold">{{ model.header }}</span>
    </div>
    <div class="mt-1 flex flex-col gap-4 text-base leading-7">
      <p v-if="model.text" class="font-light">
        {{ model.text }}
      </p>
      <slot></slot>
    </div>
  </div>
</template>
